import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Column } from "@faire/web--source/slate/Layout";
import { LoadingSkeleton } from "@faire/web--source/slate/LoadingSkeleton";
import { Spacer } from "@faire/web--source/slate/spacing";
import React from "react";
export var ProductTileLoadingSkeleton = function(param) {
    var className = param.className;
    return /*#__PURE__*/ _jsxs(Column, {
        className: className,
        "data-test-id": "product-tile-placeholder",
        children: [
            /*#__PURE__*/ _jsx(LoadingSkeleton, {
                width: "100%",
                height: "",
                aspectRatio: "1"
            }),
            /*#__PURE__*/ _jsxs(Column, {
                className: "flex-1 py-4",
                children: [
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: 4
                    }),
                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                        width: "100%",
                        height: "16px"
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: 4
                    }),
                    /*#__PURE__*/ _jsx(LoadingSkeleton, {
                        width: "75%",
                        height: "16px"
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: "1x"
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: 4
                    }),
                    /*#__PURE__*/ _jsx(Spacer, {
                        height: {
                            mobileAndAbove: "8x",
                            tabletAndAbove: "5x"
                        }
                    })
                ]
            })
        ]
    });
};
